/** @format */

import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setShowContentEditor } from "./contentEditorSlice";
import "./addEdit.scss";
import FeatureFlag from "../featureFlag/FeatureFlag";
import { useAppSelector } from "../../app/hooks";
import { selectIsEditable, selectIsEditing } from "../editable/editableSlice";
import { selectIsPrintable } from "../printable/printableSlice";
import { ReactComponent as Edit } from "bootstrap-icons/icons/pencil.svg";

type Props = {
  children?: React.ReactNode;
  action: string;
  itemId?: string;
  stage?: number;
  maxStages?: number;
  noOverlay?: boolean;
  className?: string;
  style?: React.CSSProperties;
  borderOffset?: string;
  borderRadius?: string;
};

const AddEdit: React.FC<Props> = ({
  children,
  action,
  itemId,
  stage,
  maxStages,
  noOverlay = false,
  className,
  borderOffset,
  borderRadius,
  style,
}) => {
  const dispatch = useDispatch();
  const isEditable = useAppSelector(selectIsEditable() && selectIsEditing());
  const isPrintable = useAppSelector(selectIsPrintable());

  return (
    <FeatureFlag
      flag={["editable", "dev"]}
      fallback={(children as React.ReactElement) ?? <></>}
    >
      {isEditable && !isPrintable ? (
        children ? (
          <div
            onClick={() =>
              dispatch(
                setShowContentEditor({
                  action: action,
                  itemId: itemId,
                  stage: stage,
                  maxStages: maxStages,
                }),
              )
            }
            className={`canEdit isEditable position-relative ${
              borderRadius && "border-radius-changes"
            } ${
              borderOffset === "no-offset"
                ? "no-border-offset"
                : "border-offset"
            } ${className ?? ""}`}
            style={{ ...style }}
          >
            {children}
            {!noOverlay && (
              <>
                <div
                  className="position-absolute z-2 overlay top-0 start-0 w-100 h-100"
                  style={{ cursor: "pointer" }}
                ></div>
                <div className="w-100 h-100">
                  <Edit className="position-absolute top-50 start-50 translate-middle edit-icon" />
                </div>
              </>
            )}
          </div>
        ) : (
          <div className={className} style={{ ...style }}>
            <Button
              onClick={() =>
                dispatch(
                  setShowContentEditor({
                    action: action,
                    itemId: itemId,
                    stage: stage,
                    maxStages: maxStages,
                  }),
                )
              }
              variant="outline-editing"
              className="rounded w-100 mb-4 py-0 text-center fs-4"
            >
              +
            </Button>
          </div>
        )
      ) : (
        children ?? <></>
      )}
    </FeatureFlag>
  );
};

export default AddEdit;
